import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { Button, Input } from '@xsolla/ui-core';
import { Trash } from '@xsolla/ui-icons';

import { validateUrlLink } from '../../../utils';
import { SaveButtonWrapper, Value, ValueWrapper } from './styleUrlList';

type InputProps = {
  value: string;
  onSaveClick: (value: string) => void;
  onChange: (value: string) => void;
  isDuplicate: boolean;
  fetching: boolean;
};

type ValueProps = {
  value: string;
  index: number;
  onRemoveClick: (index: number) => void;
  displayOnly: boolean;
  disabled: boolean;
};

export const InputWithSave = ({
  value,
  onSaveClick,
  onChange,
  isDuplicate,
  fetching
}: InputProps): JSX.Element | null => {
  const intl = useIntl();
  const [error, setError] = useState<boolean>(false);

  let errorMessage = '';
  if (isDuplicate) {
    errorMessage = intl.formatMessage({ id: 'app.validation.url-duplicate' });
  }
  if (error) {
    errorMessage = intl.formatMessage({ id: 'app.validation.url-invalid' });
  }

  if (value !== null) {
    const validate = (link: string) => {
      setError(!validateUrlLink(link));
      onChange(link);
    };

    const ClickableExtraIcon = () => (
      <SaveButtonWrapper>
        <Button
          look="link"
          palette="brand"
          disabled={!value || error || isDuplicate}
          fetching={fetching}
          onClick={() => onSaveClick(value)}>
          {intl.formatMessage({ id: 'dashboard.connections.save' })}
        </Button>
      </SaveButtonWrapper>
    );

    return (
      <form>
        <Input
          extra={ClickableExtraIcon}
          placeholder="https://example.com"
          extraAlign="right"
          extraAllowClick
          value={value}
          errorMessage={errorMessage}
          onChange={(ev) => validate(ev.target.value)}
        />
      </form>
    );
  }

  return null;
};

export const ValueWithRemove = ({
  value,
  index,
  onRemoveClick,
  displayOnly,
  disabled
}: ValueProps): JSX.Element => (
  <ValueWrapper>
    <Value>{value}</Value>

    {!displayOnly && (
      <Button look="icon" palette="brand" disabled={disabled} onClick={() => onRemoveClick(index)}>
        <Trash />
      </Button>
    )}
  </ValueWrapper>
);
